/**
 * @file supplier.service.js
 * @description Pure helpers for the supplier payment info shown in the suppliers pages.
 */

import { PAYMENT_FREQUENCIES } from "../constants/supplier.constants";

/**
 * Get the label of a supplier payment frequency.
 * @param {string|null} paymentFrequency - The stored payment frequency value.
 * @returns {string} The label to display, or "-" when it is not set.
 */
export function getPaymentFrequencyLabel(paymentFrequency) {
  let option = PAYMENT_FREQUENCIES.find(
    item => item.value === paymentFrequency
  );
  return option ? option.label : "-";
}
